import React from "react";
import Container from "../container/container";
import BracketButton from "../bracketButton/bracketButton";
import Button from "../button/button";
import { Link } from "react-router-dom";
import Title from "../title/title";
import Heading from "../heading/heading";
import SimpleButtonWrapper from "../simpleButtonWrapper/simpleButtonWrapper";
import ArrowRightYellow from "../svgs/icoMoon/icons/arrowRightYellow/ArrowRightYellow";
import { AWARDS_IMG_KEYBOARD, AWARDS_IMG_LOGO } from "./images";
import "./heroArea.css";
import "./awards.css";
import HeroAnimation from "../heroAnimation/heroAnimation";
import { parseCarousel } from "../../constants/parse/banners";
import { connect } from "react-redux";
import LoginLink from "../loginLink/loginLink";
import Divider from "../divider/divider";

function HeroArea(props) {
  const { isLoggedIn, carousel } = props;
  return (
    <section style={{ overflowX: "hidden", backgroundColor: "inherit" }}>
      <Container>
        <div id="nbg_effect_area">
          <div className="home-page-title">
            <Title type="section">
              <Heading level="1">
                <span className="hyper">CONNECT</span>
                <br />
                ON A GLOBAL SCALE
              </Heading>
            </Title>
            <Title type="descr">
              <span>Powerful Technology that goes far beyond banking.</span>
            </Title>
            <div className="hero-actions">
              <BracketButton
                caretEnable
                title="DISCOVER APIs"
                className="movingBrackets"
                url="/apiProducts"
              />

              {!isLoggedIn && (
                <SimpleButtonWrapper style={{ marginBottom: 2 }}>
                  <LoginLink>
                    <Button className="electro">
                      <span>REGISTER </span>
                      <ArrowRightYellow />
                    </Button>
                  </LoginLink>
                </SimpleButtonWrapper>
              )}
            </div>
          </div>
          <HeroAnimation carousel={carousel} />
          <div className="awards-section">
            <Link to="/news/best-new-dx-innovation-award-for-the-nbg-technology-hub">
              <img {...AWARDS_IMG_LOGO} />
            </Link>
            <Link to="/news/best-new-dx-innovation-award-for-the-nbg-technology-hub">
              <img {...AWARDS_IMG_KEYBOARD} />
            </Link>
          </div>
        </div>
        <Divider />
      </Container>
    </section>
  );
}

const mapStateToProps = (state) => ({
  carousel: parseCarousel(state.general?.carousel),
});

export default connect(mapStateToProps, null)(HeroArea);
